import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Flex,
  IconButton,
  Text,
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Input,
} from '@chakra-ui/react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ACCOUNTS_URL } from '../../../../Globalapi/Globalapi';

const List = () => {
  const [ledgerList, setLedgerList] = useState([]);
  const [filteredLedgers, setFilteredLedgers] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [ledgerToDelete, setLedgerToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const cancelRef = useRef();
  const cmp_id = sessionStorage.getItem('cmp_id'); // Replace with actual `cmp_id` from session or context
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLedgerList = async () => {
      try {
        const response = await axios.post(`${ACCOUNTS_URL}/ledger/list_all_ledger.php`, {
          cmp_id: cmp_id,
        });

        if (response.data.status === 'success') {
          setLedgerList(response.data.data);
          setFilteredLedgers(response.data.data);
        } else {
          console.error('No records found');
        }
      } catch (error) {
        console.error('Error fetching ledger list:', error);
      }
    };

    fetchLedgerList();
  }, [cmp_id]);

  const openDeleteModal = (Ldg_id) => {
    setLedgerToDelete(Ldg_id);
    setIsOpen(true);
  };

  const closeDeleteModal = () => {
    setLedgerToDelete(null);
    setIsOpen(false);
  };

  const confirmDelete = async () => {
    try {
      const response = await axios.post(`${ACCOUNTS_URL}/ledger/delete_ledger.php`, {
        Ldg_id: ledgerToDelete,
        cmp_id: cmp_id,
      });

      if (response.data.success) {
        setLedgerList(ledgerList.filter((ledger) => ledger.Ldg_id !== ledgerToDelete));
        setFilteredLedgers(filteredLedgers.filter((ledger) => ledger.Ldg_id !== ledgerToDelete));
      } else {
        alert('Failed to delete ledger entry');
      }
    } catch (error) {
      console.error('Error deleting ledger entry:', error);
      alert('Error deleting ledger entry');
    } finally {
      closeDeleteModal();
    }
  };

  const handleEdit = (Ldg_id) => {
    localStorage.setItem('ledgerId', Ldg_id);
    navigate('/accounts/create_ledger/edit');
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    setFilteredLedgers(
      ledgerList.filter((ledger) =>
        ledger.L_name.toLowerCase().includes(value)
      )
    );
  };

  return (
    <Box >
      <Input
        placeholder="Search ledger by name"
        value={searchTerm}
        onChange={handleSearch}
        mb={4}
      />

      <Box maxH='500px' overflowY='auto'>
        {filteredLedgers.map((ledger) => (
          <Flex
            key={ledger.Ldg_id}
            justify="space-between"
            align="center"
            p={3}
            borderBottom="1px solid #e2e8f0"
            _hover={{ bg: 'gray.100' }}
          >
            <Box>
              <Text fontWeight="bold">{ledger.L_name}</Text>
              <Text fontSize="sm" color="gray.500">
                {ledger.led_group_name}
              </Text>
            </Box>
            <Flex>
              <IconButton
                icon={<FaEdit />}
                aria-label="Edit ledger"
                bg="none"
                color="green"
                mr={2}
                onClick={() => handleEdit(ledger.Ldg_id)}
              />
              <IconButton
                icon={<FaTrash />}
                aria-label="Delete ledger"
                bg="none"
                color="red"
                onClick={() => openDeleteModal(ledger.Ldg_id)}
              />
            </Flex>
          </Flex>
        ))}
      </Box>
      {/* Delete Confirmation Modal */}
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={closeDeleteModal}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Ledger Entry
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this ledger entry? This action cannot be undone.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={closeDeleteModal}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={confirmDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default List;
